import { useState } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import saveDate from "../../../assets/img/img-header/save-date-red-155x155.jpg";
import tabActivitesClub from "../../../__params/tab-pages/programme/tab-activitesclub";
import tabActivitesJeunes from "../../../__params/tab-pages/programme/tab-activitesjeunes";
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import { motion } from "framer-motion";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Confetti from "canvas-confetti";

const buttonVariants = {
  hover: {
    scale: 1.02,
    textShadow: "0 0 8px rgb(255, 255, 255)",
  },
};

const Agenda = () => {
  const [showConfetti, setShowConfetti] = useState(false);
  // const [link, setLink] = useState("#");

  let counter = 0;

  const cardColor = [
    {
      bgColor: "#AD0000",
      textColor: "#ffffff",
    },
    {
      bgColor: "#FFA500",
      textColor: "#000000",
    },
    {
      bgColor: "#006600",
      textColor: "#ffffff",
    },
    {
      bgColor: "#00FFFF",
      textColor: "#000000",
    },
  ];

  // ******************** Regroupement des tables d'activités du club et des jeunes + Tri du résultat
  const tabNePasManquer = tabActivitesClub.concat(tabActivitesJeunes);
  tabNePasManquer.sort((a, b) => (a.dateDebut > b.dateDebut ? 1 : -1));

  const listPgmAVenir = [];
  const listNbDays = [];

  for (var i = 0; i < tabNePasManquer.length; i++) {
    const dateAnim = Date.parse(tabNePasManquer[i].dateDebut);
    const diffDays = new Date() - dateAnim;
    if (diffDays < 0) {
      if (counter < 4) {
        counter += 1;
        const gap = Date.now() - Date.parse(tabNePasManquer[i].dateDebut);
        listNbDays.push(Math.floor(gap / (24 * 60 * 60 * 1000)));
        listPgmAVenir.push(tabNePasManquer[i]);
      } else {
        break;
      }
    }
  }

  const handleClick = (lien, animation) => () => {
    if (lien === "#") {
      if (animation.slice(0, 11) === "BONNE ANNÉE") {
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 6500);
      }
    }
  };

  const launchConfetti = () => {
    // Lance les confettis
    Confetti({
      particleCount: 400,
      spread: 360,
      drift: 0.5,
      origin: {
        x: Math.random(),
        // since they fall down, start a bit higher than random
        y: Math.random() - 0.2,
      },
    });
  };

  return (
    <>
      {listPgmAVenir.map((pgm, index) => (
        <Col
          xs={12}
          sm={{ span: 6, offset: 0 }}
          md={6}
          lg={3}
          key={index}
          className="p-4 border-end"
        >
          <Nav onClick={handleClick(pgm.link, pgm.animation)}>
            <NavLink className="text-decoration-none" to={pgm.link}>
              <motion.div
                className="text-light fw-semibold"
                variants={buttonVariants}
                whileHover="hover"
              >
                <Card
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={pgm.image}
                    alt="Img not found?"
                  />
                  <Card.Img
                    className="position-absolute ms-2 mt-2 bg-light"
                    style={{ width: "20%" }}
                    variant="top"
                    src={saveDate}
                    alt="Save the date"
                  />
                  <Card.Body
                    className="rounded-bottom"
                    style={{
                      backgroundColor: `${cardColor[index].bgColor}`,
                      color: `${cardColor[index].textColor}`,
                      minHeight: "25vh",
                    }}
                  >
                    <Card.Title style={{ fontSize: "1.2rem" }}>
                      {format(parseISO(pgm.dateDebut), "EEEE d MMMM", {
                        locale: fr,
                      })}
                      <Badge bg="secondary" className="ms-2">
                        {listNbDays[index]} j
                      </Badge>
                    </Card.Title>
                    <Card.Text className="my-1 fw-bold text-decoration-underline">
                      {pgm.animation}
                    </Card.Text>
                    <Card.Text className="lh-1">{pgm.desc}</Card.Text>
                    <Card.Text className="lh-1">{pgm.lieu}</Card.Text>
                    {/* Suppression affichage du bouton VOIR si le lien = "#" ******************/}

                    {showConfetti && launchConfetti()}
                  </Card.Body>
                </Card>
              </motion.div>
            </NavLink>
          </Nav>
        </Col>
      ))}
    </>
  );
};

export default Agenda;
